import { FC } from 'react'
import styled from '@emotion/styled'
import { lastIndexChip, roundedChipNumber } from '../../utils/chips'
import { chipsRange, chipUrlWithoutNum } from '../../services/chipsets'
import { Typography } from '../Typography'
import { rpMediaQueries } from '../../core/theme'

const Img = styled.img`
  width: 25px;
  height: 25px;

  ${rpMediaQueries.tablet} {
    width: 40px;
    height: 40px;
  }
`

const Value = styled.span`
  position: absolute;
  display: flex;
  align-items: center;
`

const Chip = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

// BAB = Bonus, Ante, Bet
export const ChipOnBAB: FC<{
  amount: number
  showAmount?: boolean
  className?: string
}> = ({ amount, showAmount = true, className }) => {
  const value = roundedChipNumber(amount)
  const chip = lastIndexChip(chipsRange, amount)

  return (
    <Chip className={className}>
      <Img src={chipUrlWithoutNum[chip.lastIndex]} alt={chip.alt} />
      {showAmount && (
        <Value>
          <Typography variant="text5" as="span" color="black">
            {value}
          </Typography>
        </Value>
      )}
    </Chip>
  )
}
